const API_BASE = import.meta.env.VITE_API_BASE ?? ""

// Token storage for Mini App auth (cookies blocked in cross-origin iframes)
let authToken: string | null = null

export function setAuthToken(token: string): void {
  authToken = token
}

export function getAuthToken(): string | null {
  return authToken
}

export async function apiFetch<T>(
  path: string,
  options: RequestInit = {}
): Promise<{ status: "ok"; data: T } | { status: "error"; message: string }> {
  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(options.headers as Record<string, string>),
    }
    if (authToken) {
      headers["Authorization"] = `Bearer ${authToken}`
    }

    const response = await fetch(`${API_BASE}${path}`, {
      credentials: "include",
      headers,
      ...options,
    })

    if (!response.ok) {
      const body = await response.json().catch(() => ({ message: "Request failed" }))
      return { status: "error", message: body.message ?? `HTTP ${response.status}` }
    }

    const data = await response.json()
    return { status: "ok", data: data as T }
  } catch (error) {
    return { status: "error", message: error instanceof Error ? error.message : "Network error" }
  }
}

export function mediaUrl(mediaId: string): string {
  return `${API_BASE}/api/media/${mediaId}`
}

export function thumbUrl(mediaId: string, width = 400, height = 400): string {
  return `${API_BASE}/api/media/${mediaId}/thumb?w=${width}&h=${height}`
}
